<template>
  <v-layout>
    <v-flex xs12>
      <v-data-table
        class="elevation-3"
        item-key="promotionId"
        :headers="headers"
        :items="promotions"
        :footer-props="{
          itemsPerPageOptions: [10, 25, 50, 100, -1],
        }"
      >
        <template v-slot:[`body.prepend`]="{ isMobile }">
          <tr>
            <td :class="isMobile ? 'v-data-table__mobile-row' : ''">
              <v-text-field
                clearable
                height="25"
                color="secondary"
                v-model="filterName"
                label="Название файла"
              ></v-text-field>
            </td>
          </tr>
        </template>

        <template v-slot:[`item.start`]="{ item }">
          {{ item.start | date }}
        </template>

        <template v-slot:[`item.end`]="{ item }">
          {{ item.end | date }}
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn icon @click="editPromotion(item)">
            <v-icon>{{ icons.edit }}</v-icon>
          </v-btn>
          <v-btn icon @click="deletePromotion(item)">
            <v-icon>{{ icons.delete }}</v-icon>
          </v-btn>
        </template>

        <template v-slot:no-data>
          <v-alert :value="true" type="warning">Записи не найдены</v-alert>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import { Icon } from "@/helpers";

export default {
  props: {
    promotions: {
      type: Array,
      required: true,
    },
  },
  computed: {
    headers() {
      return [
        {
          text: "Название",
          value: "name",
          filter: (value) => {
            if (!this.filterName) return true;

            return value.search(new RegExp(this.filterName, "i")) > -1;
          },
        },
        {
          text: "Тип клиента",
          value: "organizationType",
          // filter: (value) => {
          //   if (!this.filterName) return true;

          //   return value.search(new RegExp(this.filterName, "i")) > -1;
          // },
        },
        {
          text: "Клиент",
          value: "organizationName",
          // filter: (value) => {
          //   if (!this.filterName) return true;

          //   return value.search(new RegExp(this.filterName, "i")) > -1;
          // },
        },

        {
          text: "Дата начала",
          value: "start",
        },
        {
          text: "Дата завершения",
          value: "end",
        },
        {
          text: "",
          value: "actions",
          width: "11%",
          align: "right",
          sortable: false,
        },
      ];
    },
  },
  methods: {
    editPromotion: function (item) {
      this.$emit("edit-promotion", item);
    },
    deletePromotion: function (item) {
      this.$emit("delete-promotion", item);
    },
  },
  data: () => ({
    filterName: "",
    icons: {
      delete: Icon.delete,
      edit: Icon.edit,
    },
  }),
  mounted() {},
};
</script>
